import { parseJSON } from 'hooks/useLocalStorage/useLocalStorage';
import constants from 'utils/Constants';

const safeStorage = (): Storage | null => {
  try {
    const storage = typeof localStorage !== 'undefined' ? localStorage : null;
    if (!storage || typeof storage.getItem !== 'function') return null;
    return storage;
  } catch {
    return null;
  }
};

const LanguageStorage = {
  get: () => {
    const storage = safeStorage();
    if (!storage) return null;
    const language = storage.getItem(constants.STORAGE_LANGUAGE_KEY);
    return parseJSON<string>(language);
  },
  getLangOrDefault: () => LanguageStorage.get() || constants.DEFAULT_LANGUAGE,
  set: (language: string) => {
    const storage = safeStorage();
    if (!storage) return;
    storage.setItem(constants.STORAGE_LANGUAGE_KEY, JSON.stringify(language));
  },
};

export default LanguageStorage;
